module.exports = __webpack_public_path__ + "36d7db7d0339f620d27a1ba7a0534587.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/draggable.png
// module id = 194
// module chunks = 0